import { keepPreviousData, useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import View from "views/logic/views/View";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import PaginationURL from "util/PaginationURL";
import { defaultOnError } from "util/conditional/onError";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
const savedSearchesUrl = qualifyUrl("/search/saved");
export const queryKey = (searchParams) => ["saved-searches", "overview", searchParams];
export const fetchSavedSearches = (searchParams) => {
  const url = PaginationURL(savedSearchesUrl, searchParams.page, searchParams.pageSize, searchParams.query, {
    sort: searchParams.sort.attributeId,
    order: searchParams.sort.direction,
    filters: FiltersForQueryParams(searchParams.filters)
  });
  return fetch("GET", qualifyUrl(url)).then(
    ({ elements, attributes, total, count, page, per_page: perPage }) => ({
      list: elements.map((item) => View.fromJSON(item)),
      pagination: { total, count, page, perPage },
      attributes
    })
  );
};
const useSavedSearches = (searchParams, { enabled } = { enabled: true }) => {
  const { data, refetch, isInitialLoading } = useQuery({
    queryKey: queryKey(searchParams),
    queryFn: () => defaultOnError(
      fetchSavedSearches(searchParams),
      i18n.t("save_view_notifications.load_saved_searches_failed", { ns: "search" }),
      i18n.t("save_view_notifications.could_not_load_saved_searches", { ns: "search" })
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isInitialLoading
  };
};
export default useSavedSearches;
